module.exports = __webpack_public_path__ + "img/12.2abe124d.jpg";